const SYSTEM_LABEL_NAMES_CONST = [
  "New",
  "Popular",
  "Leaving Soon",
  "Unstable",
] as const;

export const SYSTEM_LABEL_NAMES: readonly string[] = SYSTEM_LABEL_NAMES_CONST;

export type SystemLabelName = (typeof SYSTEM_LABEL_NAMES_CONST)[number];

export const CLICKABLE_LABEL_CLASS = "clickable-label";
